import React from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutlined";
import GradientIcon from "../../components/GradientIcon";

const gradientHoverSx = {
  position: "relative",
  borderRadius: "16px",
  overflow: "hidden", // Important

  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "inherit",
    padding: "2px",
    background: "linear-gradient(90deg, #FF7FAC, #5834BA)",
    WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
    opacity: 0,
    transition: "opacity 0.3s ease",
    pointerEvents: "none",
  },

  // Very very important to works correctly
  ".step-root:hover &::before": {
    opacity: 1,
  },
};

export default function StepCard({ title, description, icon, items = [] }) {
  return (
    <Box
      sx={{
        width: {
          xs: 328, // Mobile
          customBreakpoint: 380, // Tablet
          md: 241.6, // Desktop
        },

        height: 422,
        px: "16px",
        py: "48px",

        backgroundColor: "#FFF",
        borderRadius: "24px",
        boxShadow: "0px 4px 20px 0px #0000001A",

        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: "24px",
        boxSizing: "border-box",
        ...gradientHoverSx,
      }}
    >
      <GradientIcon
        icon={icon}
        size={40}
        bordered
        boxSize={80}
        borderRadius={24}
        borderWidth={2}
        // angle="90"
        // sx={{ margin: "0 auto 16px" }}
      />
      <Box>
        <Typography
          sx={{
            fontSize: "1.25rem",
            fontWeight: 700,
            letterSpacing: "0.15px",
            lineHeight: 1.6,
            mb: 1,
            color: "#000000DE",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: "0.8rem",
            fontWeight: 550,
            color: "#00000099",
            lineHeight: 1.6,
            letterSpacing: "0.1px",
          }}
        >
          {description}
        </Typography>
      </Box>

      {/* Items */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          // gap: "16px",
          mt: "5px",
        }}
      >
        {items.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              // textAlign: "left",
              gap: "8px",
              width: "100%",
            }}
          >
            {/* <CheckCircleOutlineIcon sx={checkIconSx} /> */}
            <GradientIcon
              icon={CheckCircleOutlineIcon}
              size={20}
              // bordered
              // boxSize={20}
              // borderRadius={24}
              // borderWidth={2}
              // angle="90"
              // sx={{ margin: "0 auto 16px" }}
              // sx={{ mb: "16px" }}
            />

            <Typography
              sx={{
                fontSize: "0.875rem",
                fontWeight: 400,
                color: "#00000099",
                lineHeight: 1.4,
                letterSpacing: "0.17px",
                textAlign: "left",
              }}
            >
              {item}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
